const DARKPOST_MAP = {
  'false': 'Orgânico',
  'true': 'Impulsionado',
};

export default {
  data() {
    return {
      darkpostList: DARKPOST_MAP,
    };
  },
};
